import React from 'react';

import { flagStyles } from '../settings';

const SvgPT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4368px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPT;
